// The Main Site Object
window.Site = {

    menuButton : document.querySelector('.header-button'),

    // Init Function
    liftoff : () => {
        Site.toggleNavigation()

    },

    // Toggle the main navigation on click
    toggleNavigation : () => {
        Site.menuButton.addEventListener('click' , () => {
            document.body.classList.toggle('main-navigation-is-open')
        })
    }

}

// Launch The Script
Site.liftoff()